


















































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Language from "@/models/language/language.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import i18n from "@/Plugin/i18n.ts";
import { PermissionValue } from "@/enums/PermissionValue";
import UrlForm from '@/models/urlForm.model';
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue"
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue"
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes';

@Component({
  components: {
    UserBasicInformationComponent, ResearchCenterBasicInformationComponent
  }
})
export default class Table extends GenericBTable<UrlForm> {
  isLoading = false;
  
  created() {
    this.permissionValue = PermissionValue.CUESTIONARIOONLINE;
    this.tableConfig.controller = "UrlForm";
    this.tableConfig.enableDefaultColumns = false;
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let url = new BTableColumn("url", "table.url", true);
    //let label = new BTableColumn("label", "table.label", true);
    let isActive = new BTableColumn("isActive", "table.isActive", true);

    //label.width = '10%';
    url.width = '70%';
    isActive.width = '10%';

    url.customTemplate = true;
    //label.customTemplate = true;
    isActive.customTemplate = true;

    this.tableConfig.insertColumns(url, isActive);
    //this.tableConfig.actions.customTemplate = true;
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }

  goToQestions(id: any, data: any) {
    this.$router.push(`/EvaluationType/${id}/Questions`);
  }
}
